import { openPrescriptionFile } from "../../helpers/vaParseStorage";
import {
  formatRxNumber,
  isPdfFile,
} from "../../helpers/prescriptionExtract";
import "../../styles/vaOrderModal.css";
import "../../styles/uploadPrescriptionStepModal.css";

export function PrescriptionExtractIssues({ issues = [] }) {
  if (!issues.length) return null;

  return (
    <div className="rx-extract-issues">
      {issues.map((issue) => (
        <p
          key={issue.code}
          className={`rx-extract-issue ${
            issue.blocking
              ? "rx-extract-issue--blocking"
              : "rx-extract-issue--warning"
          }`}
        >
          {issue.message}
        </p>
      ))}
    </div>
  );
}

function ExtractedValuesTable({ snapshot = {}, extractionNotes }) {
  const od = snapshot.od || {};
  const os = snapshot.os || {};
  const pd =
    snapshot.pdDistance ??
    snapshot.singularPd ??
    od.pd ??
    os.pd;

  return (
    <div className="rx-extract-values">
      <div className="rx-extract-values__header">
        <h6 className="rx-extract-values__title">AI extraction</h6>
      </div>
      <table className="rx-extract-values__table">
        <thead>
          <tr>
            <th></th>
            <th>SPH</th>
            <th>CYL</th>
            <th>AXIS</th>
            <th>ADD</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>OD (R)</th>
            <td>{formatRxNumber(od.sph ?? od.sphere)}</td>
            <td>{formatRxNumber(od.cyl ?? od.cylinder)}</td>
            <td>{formatRxNumber(od.axis, { axis: true })}</td>
            <td>{formatRxNumber(od.add)}</td>
          </tr>
          <tr>
            <th>OS (L)</th>
            <td>{formatRxNumber(os.sph ?? os.sphere)}</td>
            <td>{formatRxNumber(os.cyl ?? os.cylinder)}</td>
            <td>{formatRxNumber(os.axis, { axis: true })}</td>
            <td>{formatRxNumber(os.add)}</td>
          </tr>
        </tbody>
      </table>
      <p className="rx-extract-values__notes">
        PD: {formatRxNumber(pd)}
        {snapshot.pdType ? ` (${snapshot.pdType})` : ""}
        {extractionNotes ? ` — ${extractionNotes}` : ""}
      </p>
    </div>
  );
}

export default function PrescriptionExtractCompare({
  fileUrl,
  fileName,
  fileType,
  extractMeta,
  issues,
}) {
  const snapshot = extractMeta?.snapshot || {};
  const displayIssues = issues ?? extractMeta?.issues ?? [];
  const pdf = isPdfFile({ fileName, fileType, fileUrl });

  return (
    <div className="rx-extract-compare-wrap">
      <PrescriptionExtractIssues issues={displayIssues} />
      <div className="rx-extract-compare">
        <div className="rx-extract-preview">
          <div className="rx-extract-preview__header">
            <h6 className="rx-extract-preview__title">
              {fileName || "Prescription file"}
            </h6>
            {fileUrl && (
              <button
                type="button"
                className="rx-extract-preview__open"
                onClick={() => openPrescriptionFile(fileUrl)}
              >
                View file
              </button>
            )}
          </div>
          {fileUrl && pdf ? (
            <iframe
              className="rx-extract-preview__frame"
              title="Prescription file"
              src={fileUrl}
            />
          ) : fileUrl ? (
            <img
              className="rx-extract-preview__image"
              src={fileUrl}
              alt="Uploaded prescription"
            />
          ) : (
            <p className="rx-extract-preview__empty">
              Upload a prescription file to compare extracted values.
            </p>
          )}
        </div>
        <ExtractedValuesTable
          snapshot={snapshot}
          extractionNotes={extractMeta?.extractionNotes}
        />
      </div>
    </div>
  );
}
